const actions = {
  // participants
  async listParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.participantList",
        payload,
      );
      context.commit("setParticipantList", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipantList", []);
      throw error;
    }
  },
  async detailParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.detailParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async logParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.logParticipant",
        payload,
      );
      context.commit("setLogParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setLogParticipant", []);
      throw error;
    }
  },
  async createParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.createParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async updateParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.updateParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async actionParticipants(context, payload) {
    return await this.$api.call("employeeBenefit.actionParticipants", payload);
  },
  async checkEmailParticipants(context, payload) {
    return await this.$api.call(
      "employeeBenefit.checkEmailParticipants",
      payload,
    );
  },
  async listParticipantsByEmail(context, payload) {
    return await this.$api.call(
      "employeeBenefit.listParticipantsByEmail",
      payload,
    );
  },
  async activateParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.activateParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async approveEditParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.approveEditParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async attachCardNumberParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.attachCardNumberParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async deleteParticipant(context, payload) {
    return await this.$api.call("employeeBenefit.deleteParticipant", payload);
  },
  async exportParticipant(context, payload) {
    return await this.$api.call("employeeBenefit.exportParticipant", payload);
  },
  async exportBulkParticipant(context, payload) {
    return await this.$api.call(
      "employeeBenefit.exportBulkParticipant",
      payload,
    );
  },
  async terminateParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.terminateParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },
  async terminatePendingParticipant(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.terminatePendingParticipant",
        payload,
      );
      context.commit("setParticipant", response.data);

      return response;
    } catch (error) {
      context.commit("setParticipant", {});
      throw error;
    }
  },

  // documents
  async presignUpload(context, payload) {
    return await this.$api.call("employeeBenefit.presignUpload", payload);
  },
  async bulkCovered(context, payload) {
    return await this.$api.call("employeeBenefit.bulkCovered", payload);
  },
  async bulkPolicy(context, payload) {
    return await this.$api.call("employeeBenefit.bulkPolicy", payload);
  },

  // plans
  async listPlan(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.planList",
        payload,
      );
      context.commit("setPlanList", response.data);

      return response;
    } catch (error) {
      context.commit("setPlanList", []);
      throw error;
    }
  },
  async createPlan(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.createPlan",
        payload,
      );
      context.commit("setPlan", response.data);

      return response;
    } catch (error) {
      context.commit("setPlan", {});
      throw error;
    }
  },
  async updatePlan(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.updatePlan",
        payload,
      );
      context.commit("setPlan", response.data);

      return response;
    } catch (error) {
      context.commit("setPlan", {});
      throw error;
    }
  },
  async deletePlan(context, payload) {
    return await this.$api.call("employeeBenefit.deletePlan", payload);
  },

  // benefits
  async listBenefitType(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.benefitTypes",
        payload,
      );
      context.commit("setBenefitTypes", response.data);

      return response;
    } catch (error) {
      context.commit("setBenefitTypes", []);
      throw error;
    }
  },

  // organizations
  async listPlanByOrganizationUUID(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.planListByOrganizationUUID",
        payload,
      );
      context.commit("setPlanList", response.data);

      return response;
    } catch (error) {
      context.commit("setPlanList", []);
      throw error;
    }
  },
  async listOrganization(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.organizationList",
        payload,
      );
      context.commit("setOrganizationList", response.data);

      return response;
    } catch (error) {
      context.commit("setOrganizationList", []);
      throw error;
    }
  },
  async listEntity(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.entityList",
        payload,
      );
      context.commit("setEntityList", response.data);

      return response;
    } catch (error) {
      context.commit("setEntityList", []);
      throw error;
    }
  },
  async listInsurer(context, payload) {
    try {
      const response = await this.$api.call("organization.list", {
        query: { type: "INSURER", limit: 10000, ...payload },
      });
      context.commit("setInsurerList", response.data);

      return response;
    } catch (error) {
      context.commit("setInsurerList", []);
      throw error;
    }
  },

  // policies
  async listPolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.policyList",
        payload,
      );
      context.commit("setPolicyList", response.data);

      return response;
    } catch (error) {
      context.commit("setPolicyList", []);
      throw error;
    }
  },
  async detailPolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.detailPolicy",
        payload,
      );
      context.commit("setPolicy", response.data);

      return response;
    } catch (error) {
      context.commit("setPolicy", {});
      throw error;
    }
  },
  async createPolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.createPolicy",
        payload,
      );
      context.commit("setPolicy", response.data);

      return response;
    } catch (error) {
      context.commit("setPolicy", {});
      throw error;
    }
  },
  async updatePolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.updatePolicy",
        payload,
      );
      context.commit("setPolicy", response.data);

      return response;
    } catch (error) {
      context.commit("setPolicy", {});
      throw error;
    }
  },
  async archivePolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.archivePolicy",
        payload,
      );
      context.commit("setPolicy", response.data);

      return response;
    } catch (error) {
      throw error;
    }
  },
  async unarchivePolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.unarchivePolicy",
        payload,
      );
      context.commit("setPolicy", response.data);

      return response;
    } catch (error) {
      throw error;
    }
  },
  async fetchBulkPolicyTemplate(context, payload) {
    try {
      const response = await this.$api.call(
        "employeeBenefit.fetchBulkPolicyTemplate",
        payload,
      );
      context.commit("setBulkPolicyTemplate", response.data);

      return response;
    } catch (error) {
      context.commit("setBulkPolicyTemplate", "");
      throw error;
    }
  },
  async exportPolicy(context, payload) {
    const response = await this.$api.call(
      "employeeBenefit.exportPolicy",
      payload,
    );

    return response;
  },
};

export default actions;
